import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=4d6b1f32"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports